/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIm } from '../../factoriesAny.js';
export var imDependencies = {
  typedDependencies,
  createIm
};